module.exports = "/images/loader.svg?c3ee6b0b3ad29ae28d0928eaa8b65584";